import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=9bab898c&scoped=true"
import script from "./PieChart.vue?vue&type=script&lang=js"
export * from "./PieChart.vue?vue&type=script&lang=js"
import style0 from "./PieChart.vue?vue&type=style&index=0&id=9bab898c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bab898c",
  null
  
)

export default component.exports